module.exports = __webpack_public_path__ + "img/link.cdb5d7bb.svg";